import {OccPriceDisplayText} from '@vista/omnichannel-components-ui'
import {defaultOccPriceDisplayText} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/display-text/price'

export function getPriceDisplayText():OccPriceDisplayText {
    return {
        ...defaultOccPriceDisplayText,
    }
}